// Relative time formatter for operator UIs ("3m ago", "12s ago", "in 4h").
// Bridges between a UTC timestamp from the API and a human-readable label
// without pulling a full i18n lib. Locale is hardcoded ES per § 5.1 MVP.

const UNITS = [
  { ms: 1000, label: 's' },
  { ms: 60_000, label: 'm' },
  { ms: 3_600_000, label: 'h' },
  { ms: 86_400_000, label: 'd' },
] as const;

export function formatRelativeTime(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '—';
  const diff = t - now;
  const abs = Math.abs(diff);

  // Pick the largest unit that fits (or fall back to seconds for sub-minute).
  // UNITS is non-empty so the assertion-free fallback is the seconds entry.
  let chosen: { ms: number; label: string } = UNITS[0];
  for (const u of UNITS) {
    if (abs >= u.ms) chosen = u;
  }
  const value = Math.floor(abs / chosen.ms);
  if (diff < 0) return `hace ${value}${chosen.label}`;
  return `en ${value}${chosen.label}`;
}

// Compact "time-until" for windows that count down (signal validUntil).
//   formatCountdown(t) → "12m 34s" / "0s" if past
export function formatCountdown(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '—';
  const diff = t - now;
  if (diff <= 0) return '0s';
  const totalSec = Math.floor(diff / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}
